'use strict';

module.exports = function containsOneItem() {
  return this.count() === 1;
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/containsOneItem.js
// module id = 1639
// module chunks = 2